(ns core.user.model
  (:require [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.util.string :as str-util]))

(def notification-types
  [:user.notification-type/new-workspace-submitted
   :user.notification-type/inspection-request-submitted
   :user.notification-type/inspection-request-modified
   :user.notification-type/direct-message
   :user.notification-type/public-message
   :user.notification-type/requested-changes-marked-done
   :user.notification-type/circulation-completed
   :user.notification-type/circulation-due
   :user.notification-type/review-due
   :user.notification-type/application-assigned
   :user.notification-type/previous-review-completed
   ;; deprecated for now - this is for circulees to control their notifications, but it was
   ;; decided that it will be withheld until further specification. We need it here in order to
   ;; not break schema checks for profile page load.
   :user.notification-type/circulation-updated
   :user.notification-type/attachment-added-or-deleted-in-reviewed-workspace
   :user.notification-type/attachment-modified-in-assigned-workspace
   :user.notification-type/attachment-modified-in-inspector-workspace
   :user.notification-type/circulation-request-completed-for-workspace-assignee
   :user.notification-type/circulation-unsuccessful
   :user.notification-type/deficiency-comply-by-date-approaches
   :user.notification-type/condition-due-date-approaches
   :user.notification-type/payment-completed
   :user.notification-type/work-order-created
   :user.notification-type/complaint-created
   :user.notification-type/work-order-assigned-to-you
   :user.notification-type/work-order-in-progress
   :user.notification-type/work-order-completed
   :user.notification-type/work-order-cancelled
   :user.notification-type/work-task-created
   :user.notification-type/work-task-assigned-to-you
   :user.notification-type/work-task-in-progress
   :user.notification-type/work-task-completed
   :user.notification-type/work-task-cancelled
   :user.notification-type/bond-verification-needed
   :user.notification-type/bond-verified
   :user.notification-type/bond-about-to-expire
   :user.notification-type/bond-expired
   :user.notification-type/bond-closed
   :user.notification-type/bond-updated
   :user.notification-type/bond-reopened
   :user.notification-type/property-verification-needed])

(def config-flags #{:user.config-flag/dispatch-map-hidden?
                    :user.config-flag/prefers-licence-dashboard-map-view?
                    :user.config-flag/prefers-dashboard-list-view?
                    :user.config-flag/prefers-bluebeam-browser?
                    :user.config-flag/prefers-bluebeam-desktop?})


(defn language [user] (:user/locale user i18n-model/default-lang))


(defn full-name
  "Return the full name of the user"
  [{:user/keys [first-name last-name]}]
  (->> [first-name last-name]
       (remove str/blank?)
       (map str/trim)
       (str/join " ")))


(defn initials [{:user/keys [first-name last-name]}]
  (str (first first-name) (first last-name)))


(defn user-sort [current-user-id u1 u2]
  (cond
    (= current-user-id (:db/id u1)) -1
    (= current-user-id (:db/id u2)) 1
    :else
    (let [fnc (compare (:user/first-name u1) (:user/first-name u2))]
      (if (zero? fnc)
        (compare (:user/last-name u1) (:user/last-name u2))
        fnc))))


(defn user-sort-lastname
  ([u1 u2] (user-sort-lastname nil u1 u2))
  ([current-user-id u1 u2]
   (cond
     (= current-user-id (:db/id u1)) -1
     (= current-user-id (:db/id u2)) 1
     :else
     (let [fnc (compare (:user/last-name u1) (:user/last-name u2))]
       (if (zero? fnc)
         (compare (:user/first-name u1) (:user/first-name u2))
         fnc)))))

(defn user-with-group
  "e.g. Sonja Sibbo (Windsor Planning Department)"
  [user auth-group authority?]
  (let [group (if authority?
                (:group/name auth-group)
                (:user/corporation-or-partnership user))]
    (cond-> (full-name user)
      group (str " (" group ")"))))

(defn service-account? [user]
  (-> user :user/type (= :user.type/service-account)))

(defn audit-log-user [tr user]
  (or (-> user
          full-name
          str-util/blank->nil)
      (when (service-account? user)
        (str (tr [:system])
             (when (:user/username user)
               ;; missing, if this is a frontend entity exported for an unprivileged user
               (str " (" (:user/username user) ")"))))))
